module.exports = __webpack_public_path__ + "img/coats-of-arms.fde2ee73.svg";